import { createFileRoute } from '@tanstack/react-router';

import { AttributionPageContent } from '@/components/layout/pages/attribution-page';
import { staticPageHead } from '@/config/seo-head';

export const Route = createFileRoute('/attribution')({
  head: () => staticPageHead('/attribution'),
  component: AttributionPageContent,
});
